import store from "@/store/store";

export default function (config) {
    if (store.state.auth.token) {
        config.headers['Authorization'] = `Bearer ${store.state.auth.token}`
    }
    return config;
}
